<template>
    <div class="g-bd">
        <div class="g-hd">
            <div class="ttBox">
                <img class="back" v-show="isback" src="../assets/jxwx/return.png" alt="" @click="backward()">
                <span class="tt">仓储部</span>
                <!-- <span class="directorName">{{data.directorName | nameP}}</span> -->
            </div>
        </div>
        <div class="tabBox">
            
                    <ul class="hdList">
                        <li>
                            <div class="lf">
                                <div class="tt">本月绩效累计(元)</div>
                                <div class="num">{{result.monthTotal.totalFee | moneyP}}</div>
                            </div>
                            <div class="rg">
                                <div class="tt">昨日绩效(元)</div>
                                <div class="num mark">{{result.total.totalFee | moneyP}}</div>
                            </div>
                        </li>
                    </ul>
                    <section class="f-bcf f-mgb">
                        <!-- <van-tabs v-model="tabName" @click="handleClick">
                            <van-tab v-for="item in tabList" :key="item.id" :title=item.tt :name=item.tt></van-tab>
                        </van-tabs> -->
                        <div class="chartBox">

                            <ve-line :extend="chartExtend" :data="chartData" height="220px"></ve-line>
                        </div>
                        <ul class="timeList">
                            <li v-for="(item,index) in timeList" :key="item.id" :class="{active:timeActive == index}" @click="timeChoose(index)">{{item.time}}</li>
                        </ul>
                    </section>

                   
                     <div class="u-card cardBox" v-for="item in result.groupDetail.feeDetail" :key="item.id" @click="toRecordDetail(item)">
                        <div class="hd" @click="toWhTeamLeader(item)" @click.stop>
                            <img class="icon" src="../assets/jxwx/icon_03.png" alt="">
                            <div class="tt">
                                <span>{{item.groupName}}</span>
                                
                            </div>
                            <img class="arr" src="../assets/jxwx/arr_05.png" alt="">
                        </div>
                         <div class="bd">
                            <div class="lf">
                                <div class="tt">本月绩效累计(元)</div>
                                <div class="num">{{item.totalFee.fee | moneyP}}</div> 
                            </div>
                            <div class="rg">
                                <div class="tt">昨日绩效(元)</div>
                                <div class="num" v-if="item.yesterdayFee">{{item.yesterdayFee.fee | moneyP}}</div>
                            </div>
                        </div> 
                    </div> 
        </div>

    </div>
</template>

<script>
import api from "@/axios/api";
import { wlapi } from "@/axios/api";
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters(["token"])
  },
  watch: {
    token: {
        immediate: true,
        handler: function(val) {
            if (val) {
                this.getResultBydepta();
            }
        }
    }
  },
  data() {
    return {
      data: {},
      data2: {},
      arr: [],
      isItem: false,
      tabName: "全部",
      timeActive: 0,
      chartExtend: {
        grid: {
          x: 20,
          y: 60,
          x2: 30,
          y2: 5
        },
        series: {
          symbol: "none"
        },
        xAxis: {
          axisLine: {
            show: true,
            lineStyle: {
              color: "#dedede"
            }
          },
          axisLabel: {
            textStyle: {
              color: "#a6a6a6",
              fontSize: 13
            }
          }
        },
        yAxis: {
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#a6a6a6",
              fontSize: 13
            }
          },
          splitLine: {
            //网格线
          }
        }
      },
      chartData: {
        columns: [],
        rows: []
      },
      tabList: [{ tt: "全部" }],
      timeList: [
        {
          time: "近1月"
        },
        // {
        //     time: "近3月"
        // },
        {
          time: "近6月"
        },
        {
          time: "近1年"
        }
      ],
      classData: [],
      monthdayList: [],
      sixMonthList: [],
      yearList: [],

      // directorId: this.$route.query.directorId,
      today: this.$route.query.today,
      departmentCode: this.$route.query.departmentCode,
      departmentId: this.$route.query.departmentId,
      isback: this.$route.query.isback,
      result: {}
    };
  },
  filters: {
    nameP: function(value) {
      if (value) {
        return value.split("(")[0];
      }
    }
  },
  mounted() {
    //  this.getResultBydept(this.departmentId, this.directorId, this.today);
    //  this.getDailyCountData(this.today,this.departmentId);
    // this.getResultBydepta();
  },
  methods: {
    // isShowItem() {
    //     this.isItem = !this.isItem;
    // },
    getResultBydepta() {
      let params = {
        today: this.today,
        departmentCode: this.departmentCode,
        departmentId: this.departmentId
      };
      wlapi.getResultBydept(params).then(res => {
        this.result = res.result;
        let arr = this.result.groupDetail.feeDetail;
        let a = [];
        let columns = ["日期"];
        for (let i = 0; i < arr.length; i++) {
          this.tabList.push({ tt: arr[i].groupName });
          columns.push(arr[i].groupName);
        }
        this.chartData.columns = columns;

        let directorCurve = this.result.curveDetail.totalCurve;
        let monthdayList = [];
        let sixMonthList = [];
        let yearList = [];
        for (let i = 0; i < directorCurve.length; i++) {
          monthdayList.push(directorCurve[i].monthCurve.reverse());
          sixMonthList.push(directorCurve[i].sixMonthCurve.reverse());
          yearList.push(directorCurve[i].yearCurve.reverse());
        }
        let len = monthdayList[0].length;
        let len2 = sixMonthList[0].length;
        let len3 = yearList[0].length;
        for (let j = 0; j < len; j++) {
          let arr = [];
          for (let i = 0; i < monthdayList.length; i++) {
            arr.push(monthdayList[i][j]);
          }
          this.monthdayList.push(arr);
        }
        //console.log(this.monthdayList);
        for (let j = 0; j < len2; j++) {
          let arr = [];
          for (let i = 0; i < sixMonthList.length; i++) {
            arr.push(sixMonthList[i][j]);
          }
          this.sixMonthList.push(arr);
        }
        for (let j = 0; j < len3; j++) {
          let arr = [];
          for (let i = 0; i < yearList.length; i++) {
            arr.push(yearList[i][j]);
          }
          this.yearList.push(arr);
        }
        this.lineData(this.tabName);
      });
    },

    toGroupDetails(item) {
      this.$router.replace({
        path: "/jxwx/groupDetails",
        query: {
          data: item,
          time: this.today
        }
      });
    },
    backward() {
      this.$router.backward();
      // alert(this.$route.params.isBack)
    },
    handleClick(name) {
      this.classData = [];
      
      this.lineData(this.tabName);
    },
    timeChoose(index, title) {
      this.timeActive = index;
      this.classData = [];
      this.lineData(this.tabName);
    },
    lineData(itemName) {
        
      switch (this.timeActive) {
        case 0:
          this.monthdayList.forEach(item => {
            this.itemChoose(itemName, item);
          });
          this.chartData.rows = this.classData;
          break;
        case 1:
          this.sixMonthList.forEach(item => {
            this.itemChoose2(itemName, item);
          });
          this.chartData.rows = this.classData;
          break;
        case 2:
          this.yearList.forEach(item => {
            this.itemChoose2(itemName, item);
          });
          this.chartData.rows = this.classData;
          break;
      }
    },
    itemChoose(itemName, item) {
        
      switch (itemName) {
        case "全部":
          // console.log(item);
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "整件组":
        
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "零货组":
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "收货组":
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "中药组":
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
        case "内复核":
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
        case "其他-待定":
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
        case "退货组":
          var i = {
            日期: item[0].feeDate
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
      }
    },
    itemChoose2(itemName, item) {
      switch (itemName) {
        case "全部":
          // console.log(item);
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "整件组":
        
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "零货组":
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "收货组":
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
          break;
        case "中药组":
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
        case "内复核":
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
        case "其他-待定":
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
        case "退货组":
          var i = {
            日期: item[0].month
          };
          item.forEach((item, index) => {
            let key = item.groupName;
            i[key] = item.totalFee;
          });
          this.classData.push(i);
      }
    },
    getResultBydept(departmentId, directorId, today) {
      let params = {
        departmentId: departmentId,
        directorId: directorId,
        today: today
        // departmentId: "1",
        // directorId: "1",
        // today: "1"
      };
      api.getResultBydept(params).then(res => {
        this.data = res.result;

        let arr = res.result.directorCurve;
        let columns = ["日期"];
        for (let i = 0; i < arr.length; i++) {
          let name = "组" + (i + 1);
          columns.push(name);
        }
        this.chartData.columns = columns;

        let directorCurve = this.data.directorCurve;
        let monthdayList = [];
        let sixMonthList = [];
        let yearList = [];
        for (let i = 0; i < directorCurve.length; i++) {
          monthdayList.push(directorCurve[i].monthDetail.reverse());
          sixMonthList.push(directorCurve[i].sixmonthDetail.reverse());
          yearList.push(directorCurve[i].yearhDetail.reverse());
        }
        let len = monthdayList[0].length;
        let len2 = sixMonthList[0].length;
        let len3 = yearList[0].length;
        for (let j = 0; j < len; j++) {
          let arr = [];
          for (let i = 0; i < monthdayList.length; i++) {
            arr.push(monthdayList[i][j]);
          }
          this.monthdayList.push(arr);
        }

        for (let j = 0; j < len2; j++) {
          let arr = [];
          for (let i = 0; i < sixMonthList.length; i++) {
            arr.push(sixMonthList[i][j]);
          }
          this.sixMonthList.push(arr);
        }
        for (let j = 0; j < len3; j++) {
          let arr = [];
          for (let i = 0; i < yearList.length; i++) {
            arr.push(yearList[i][j]);
          }
          this.yearList.push(arr);
        }
        this.lineData(this.tabName);
      });
    },
    toRecordDetail(item) {
            this.$router.replace({
                path: "/wljx/details",
                query: {
                    today:this.today,
                    item: item
                }
            });
        },
        toWhTeamLeader(item) {
            this.$router.replace({
                path: "/wljx/whTeamLeader",
                query: {
                    endtime:this.today,
                    business_id: item.groupId,
                    isback: true
                }
            });
        },
        // toDirectorDetail() {
        //     this.$router.replace({
        //         path: "/jxwx/details",
        //         query: {
        //             name: this.data.directorName,
        //             title: "主任绩效",
        //             data: this.data.directorJXRecordDetail
        //         }
        //     });
        // },
        // toTeamLeader(item) {
        //     this.$router.replace({
        //         path: "/jxwx/teamLeader",
        //         query: {
        //             groupId: item.group_id,
        //             date: item.feedate,
        //             isback: true
        //         }
        //     });
        // }
  }
};
</script>

<style lang="less" scoped>
.g-bd {
  margin-bottom: 60px;
}
.g-hd {
  padding-top: 2vw;
  background: #e5323b;
  .ttBox {
    display: flex;
    align-items: center;
    margin-left: 4vw;
    padding: 2vw 0;
    .back {
      width: 2vw;
      margin-right: 2.6vw;
    }
    .tt {
      margin-right: 4vw;
      font-size: 18px;
      color: #fff;
    }
    .directorName {
      font-size: 13px;
      color: #ff9d9e;
    }
  }
}
.hdList {
  margin-bottom: 2.6vw;
  background: #e5323b;
  li {
    display: flex;
    justify-content: space-between;
    padding: 3vw 4vw 0 4vw;
    .lf {
      text-align: left;
    }
    .rg {
      text-align: right;
    }
    .tt {
      margin-bottom: 3vw;
    }
  }
  li:first-child {
    padding-bottom: 3vw;
    .tt {
      font-size: 13px;
      color: #ff9c9d;
    }
    .num {
      font-size: 30px;
      color: #fff;
    }
    .mark {
      color: #fccd33;
    }
  }
  li:nth-child(2) {
    padding: 0;
  }
  li:nth-child(3) {
    justify-content: center;
    align-items: center;
    height: 5.3vw;
    padding: 0;
    img {
      width: 2.5vw;
    }
    .arr2 {
      transform: rotate(180deg);
    }
  }
  .itemBox {
    display: flex;
    flex-wrap: wrap;
    padding-top: 3vw;
    .item {
      width: 50%;
      box-sizing: border-box;
      padding: 2vw 4vw;
      border-bottom: 1px solid#EF5E65;
      .tt {
        margin-bottom: 2vw;
        font-size: 13px;
        color: #fff;
      }
      .lf {
        font-size: 13px;
        color: #ff9c9d;
      }
      .rg {
        font-size: 13px;
        color: #fccd33;
      }
    }
    .item:nth-child(1) {
      border-top: 1px solid#EF5E65;
    }
    .item:nth-child(2) {
      border-top: 1px solid#EF5E65;
    }
    .item:nth-child(odd) {
      border-right: 1px solid#EF5E65;
    }
  }
}

.van-tabs {
  /deep/.van-tabs__wrap {
    border-bottom: 1px solid #dedede;
  }
  /deep/.van-tab--active {
    color: #e5323b;
  }
  /deep/.van-tabs__line {
    width: 10.4vw !important;
  }
  .rankBox {
    // height: 32.6vw;
    background-color: #fff;
    .rangeList {
      li {
        display: flex;
        align-items: center;
        height: 10.6vw;
        div {
          flex: 1;
          text-align: center;
          font-size: 14px;
        }
        .date {
          color: #a6a6a6;
        }
      }
      li:first-child {
        font-size: 13px;
        color: #a6a6a6;
        background-color: #fafcff;
        border-bottom: 1px solid #dedede;
      }
    }
  }
}
.tabBox {
  /deep/.tabWrap {
    & > .van-tabs__wrap {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      border-top: 1px solid #dedede;
      border-bottom: none;
      z-index: 999;
      .van-tab--active {
        background: #e5323b;
        color: #fff;
      }
      .van-tabs__line {
        height: 0;
      }
    }
  }
}
.timeList {
  display: flex;
  background-color: #fafcff;
  height: 9.2vw;
  font-size: 13px;
  color: #a6a6a6;
  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-top: 1px solid #dedede;
  }
  li.active {
    color: #2c2c2c;
    background-color: #fff;
    border-top: 1px solid #fff;
    border-right: 1px solid #dedede;
    border-left: 1px solid #dedede;
  }
  li:first-child.active {
    border-left: none;
  }
  .customizeBtn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 14.6vw;
    height: 6.4vw;
    line-height: 1;
    border: 1px solid #0897ea;
    border-radius: 6px;
    color: #0897ea;
    box-sizing: border-box;
  }
}
.detailsBox {
  display: flex;
  padding: 4.6vw 0 3.2vw 0;
  div {
    flex: 1;
    text-align: center;
    font-size: 13px;
    img {
      width: 6vw;
      margin-bottom: 2vw;
    }
  }
}
.chartBox {
  padding-top: 3vw;
}
.u-card {
  margin: 2.6vw 4vw;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
  border-radius: 6px;
}
.cardBox {
  .hd {
    display: flex;
    font-size: 13px;
    align-items: center;
    height: 12vw;
    padding: 0 4vw;
    border-bottom: 1px solid #dedede;
    .icon {
      width: 4vw;
    }
    .tt {
      display: flex;
      justify-content: space-between;
      width: 80vw;
      margin: 0 3.2vw 0 1.6vw;
    }
    .arr {
      width: 1.3vw;
    }
  }
  .bd {
    display: flex;
    justify-content: space-between;
    padding: 4vw;
    .tt {
      margin-bottom: 3.2vw;
      font-size: 13px;
      color: #a6a6a6;
    }
    .num {
      font-size: 18px;
    }
  }
}

.main {
  /deep/.van-tabs {
    margin-top: 2.6vw;
    background: #fff;
    .van-tabs__wrap {
      border-bottom: 1px solid#E0DFDF;
    }
    .van-tab--active {
      color: #5584ff;
    }
    .van-tabs__line {
      width: 16vw !important;
      background-color: #5584ff;
    }
  }
}

.u-card {
  margin: 2.6vw 4vw 0 4vw;
  // background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
  // border-radius: 6px;
}
.cardBox2 {
  .hd {
    display: flex;
    font-size: 13px;
    justify-content: space-between;
    align-items: center;
    height: 12vw;
    padding: 0 4vw;
    border-bottom: 1px solid #dedede;
    .icon {
      width: 4vw;
    }
    .tt {
      display: flex;
      align-items: center;
      img {
        margin-right: 1.6vw;
      }
    }
    .arr {
      width: 1.3vw;
    }
  }
  .bd {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 2vw 0 1.4vw 0;
    .m-hos {
      width: 50%;
      padding: 0 2vw;
      box-sizing: border-box;
      .f-df {
        display: flex;
        align-items: center;
      }
    }
    // .m-hos2 {
    //     width: 42vw;
    //     padding: 0 ;
    // }
    .m-hos header {
      margin-bottom: 3.4667vw;
      font-size: 14px;
      color: #4c4c4c;
    }
    .m-hos header img {
      width: 1.3333vw;
      margin-right: 1.3333vw;
    }
    .m-hos .progress {
      width: 100%;
      height: 2.1333vw;
      margin-bottom: 2.6667vw;
      border-radius: 1.0667vw;
      background-color: #efefef;
      overflow: hidden;
      .progress_bar {
        height: 100%;
        background-color: #fed100;
      }
      .progress_bar2 {
        height: 100%;
        background-color: #91c619;
      }
      .progress_bar3 {
        height: 100%;
        background-color: #f66969;
      }
    }

    .m-hos .entry {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 3.2vw;
      font-size: 12px;
    }
    .m-hos > .entry > .ctt {
      color: #8f8f8f;
    }
    .m-hos > .entry > .nm {
      font-size: 13px;
      color: #282828;
    }
    .m-hos > .entry > .mark {
      color: #f66969;
      background: #fff;
    }
    .m-hos > .entry > .mark2 {
      color: #91c619;
    }
  }
}
.f-bc {
  padding: 2.6vw 0;
  background: #f7f7f7;
  .u-card {
    margin: 2.6vw 4vw;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 4px 0px rgba(225, 225, 225, 0.42);
    border-radius: 6px;
  }
  .cardBox {
    .hd {
      display: flex;
      font-size: 13px;
      justify-content: start;
      align-items: center;
      height: 12vw;
      padding: 0 4vw;
      border-bottom: 1px solid #dedede;
      .icon {
        width: 4vw;
      }
      .tt {
        display: flex;
        justify-content: space-between;
        width: 45vw;
        margin: 0 3.2vw 0 1.6vw;
      }
      .arr {
        width: 1.3vw;
      }
    }
    .bd {
      display: flex;
      justify-content: space-between;
      padding: 4vw;
      .tt {
        margin-bottom: 3.2vw;
        font-size: 13px;
        color: #a6a6a6;
      }
      .num {
        font-size: 18px;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/wljx/whManager.vue